enum TribeTypes {
  Discussion = "discussion",
  Information = "information",
}

export default TribeTypes;
